import "./KnowledgeCenter.css";
import Books from "../Books/Books";
import AddBreak from "../AddBreak/AddBreak";
import Exercise from "../Exercise/Exercise";
import Profile from "../Profile/Profile";
import BreakTime from "../BreakTime/BreakTime";
import CompletedButton from "../CompletedButton/CompletedButton";
import { useEffect, useState } from "react";
import { AddToDb, getDataFromStorage } from "../../Utilities/Storage";

function KnowledgeCenter() {
  const [cart, setCart] = useState([]);
  const [breakTime, setBreaktime] = useState(0);

  const AddTimeToExercise = (book) => {
    let newCart = [];
    newCart = [...cart, book];
    setCart(newCart);
  };

  const AddTen = (second) => {
    setBreaktime(second);
    AddToDb(second);
  };

  useEffect(() => {
    let storeBreakTime = getDataFromStorage();
    console.log(storeBreakTime);
    setBreaktime(storeBreakTime);
  }, [breakTime]);

  return (
    <div className="row mb-5">
      <div className="col-md-9 col-12 m-auto book-container">
        <Books AddTimeToExercise={AddTimeToExercise}></Books>
      </div>
      <div className="col-md-3 col-12 cart-container p-4">
        <Profile></Profile>
        <AddBreak AddTen={AddTen}></AddBreak>
        <Exercise cart={cart}></Exercise>
        <BreakTime breakTime={breakTime}></BreakTime>
        <CompletedButton></CompletedButton>
      </div>
    </div>
  );
}

export default KnowledgeCenter;
